import React from 'react'
import { Container, Row } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';

export const Faq = () => {
  return (
        <section className='faq-section'>
            <Container>
                <div className='opportunities-text' data-aos="fade-right" data-aos-duration="2000">
                    <h5>FAQ</h5>
                    <h4>Have questions? We’ve got answers. Whether you’re curious about our hiring process, work culture, or current openings, we’re here to guide you every step. </h4>
                </div>
                <Row className='align-items-center'>
                    <div className='col-lg-6' data-aos="fade-up-right"  data-aos-duration="2000">
                        <div className='position-relative faq-margin'>
                            <div className='faq-img text-center'>
                                <img src="../assets/images/faq-img.png" alt="" />
                            </div>

                            <div className='faq-shap-1'>
                                <img src="../assets/images/faq-shap-1.svg" alt="" />
                            </div>
                            <div className='faq-shap-2'>
                                <img src="../assets/images/faq-shap-2.svg" alt="" />
                            </div>
                            <div className='faq-shap-3'>
                                <img src="../assets/images/faq-shap-3.svg" alt="" />
                            </div>
                            <div className='faq-shap-4'>
                                <img src="../assets/images/faq-shap-4.svg" alt="" />
                            </div>
                            <div className='faq-shap-5'>
                                <img src="../assets/images/faq-shap-5.svg" alt="" />
                            </div>
                            <div className='faq-shap-6'>
                                <img src="../assets/images/faq-shap-6.svg" alt="" />
                            </div>
                            <div className='faq-shap-7'>
                                <img src="../assets/images/faq-shap-7.svg" alt="" />
                            </div>
                            <div className='faq-shap-8'>
                                <img src="../assets/images/faq-shap-8.svg" alt="" />
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-6'>
                        <div className='faq-accordion'>
                            <Accordion defaultActiveKey="0" flush>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>What services does IMUII Technology offer? </Accordion.Header>
                                    <Accordion.Body>We provide a wide range of IT solutions including web development, mobile app development, UI/UX design, E-commerce platforms, and CMS solutions. Our team also specializes in cloud integration, analytics, and creating custom tech for startups and enterprises to support growth, scalability, and long-term success. </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>How long does it take to complete a typical project? </Accordion.Header>
                                    <Accordion.Body> Project timelines depend on complexity, but most websites are delivered in 4–8 weeks. Mobile applications may take 8–12 weeks. We follow agile methodology and keep clients updated through every phase to ensure we meet your business goals without compromising on quality or performance. </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Can you help with post-launch support and updates? </Accordion.Header>
                                    <Accordion.Body>Yes, we offer complete post-launch services including maintenance, updates, bug fixes, and new feature development. Our support ensures your digital solution stays current, secure, and functional across devices and platforms. We’re here to help even after the project is live and running. </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>Do you provide custom design or use templates? </Accordion.Header>
                                    <Accordion.Body> All our designs are custom-made. We don’t rely on generic templates. Every project begins with deep research and ideation to create a unique, user-focused experience. Our UI/UX experts ensure your product not only looks great but also works perfectly for your target audience. </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </div>
                </Row>
            </Container>
        </section>
  )
}
